import { FC } from 'react';
import { BrandedBackground } from 'shared/ui/branded-background/ui';
import styles from './styles.module.scss';
export const Main: FC = () => (
 <section className={styles.main} id="ansar" aria-labelledby="hero-title">
  <BrandedBackground scene="workstation" className={styles.backdrop} loading="eager" />
  <div className={styles.inner}>
   <div className={styles.copy}>
    <p className={styles.eyebrow}>Школа программирования · Грозный и онлайн</p>
    <h1 id="hero-title">Научитесь <span>программировать.</span></h1>
    <p className={styles.intro}>Python, веб-разработка и основы работы с компьютером. В курсах программирования изучаем AI-инженерию и создаём проекты с ИИ.</p>
    <div className={styles.actions}>
     <a href="#courses" className={styles.primary}>Выбрать курс <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 4v16m-6-6 6 6 6-6" /></svg></a>
     <a href="#feedback" className={styles.secondary}>Помогите с выбором</a>
    </div>
   </div>
   <ul className={styles.facts}><li>С нуля и с опытом</li><li>Группы и индивидуально</li><li>Обычный и интенсивный темп</li></ul>
  </div>
 </section>
);
